import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState('undefined');

  const location = useLocation();

  useEffect(() => {
    const authToken = localStorage.getItem('ieeextremeLoginfo');
    console.log(authToken);
    if (authToken) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }
  }, [location]);
  

  if (isAuthenticated===false) {
    // Redirect to the login page
    return <Navigate to='/login' />
  }

  return children;
};

export default ProtectedRoute;
